import createIcon from "components/elements/Icons/create-icon";

export default createIcon("ArrowLeft", [
  [
    "path",
    {
      d: "M4.5 12C4.5 11.7238 4.72386 11.5 5 11.5H19C19.2762 11.5 19.5 11.7238 19.5 12C19.5 12.2762 19.2762 12.5 19 12.5H5C4.72386 12.5 4.5 12.2762 4.5 12Z",
    },
  ],
  [
    "path",
    {
      d: "M5.7071 12L6.06066 11.6464L12.3535 5.35357C12.3535 5.35357 12.3535 5.35356 12.3535 5.35356C12.5488 5.15828 12.5488 4.8417 12.3535 4.64643M5.7071 12L12.3535 4.64643M5.7071 12L6.06066 12.3536L12.3535 18.6465C12.5488 18.8417 12.5488 19.1583 12.3535 19.3535C12.1583 19.5488 11.8417 19.5488 11.6465 19.3535L4.64644 12.3535L4.64643 12.3535C4.45119 12.1583 4.45119 11.8417 4.64643 11.6465L4.64644 11.6465L11.6465 4.64644L11.6465 4.64643C11.8417 4.45119 12.1583 4.45119 12.3535 4.64643M5.7071 12L12.7071 4.29289L12.3535 4.64643",
    },
  ],
]);
